import * as React from 'react';
import FormField from '../../FormElements/Field';
import SubmitButton from '../../FormElements/SubmitButton';
import { useBankAccountEdit } from './useBankAccountEdit';
import { useForm } from 'react-hook-form';
import { BankAccount } from '../../../Model/BankAccount';

export const BankAccountNameEditForm = () => {
  const { register, reset, handleSubmit } = useForm<Pick<BankAccount, 'displayName'>>();
  const { onSubmit, onClose, inProgress, bankName } = useBankAccountEdit(register, reset);
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField name="bankaccountName" label="A bankszámla új neve:">
          <div>
            <input
              type="text"
              className="form-control"
              id="bankAccountName"
              data-testid="bankNameChangeInput"
              defaultValue={bankName}
              {...register('displayName')}
            />
            <p>
              <span className="text-primary">*</span>Üresen a bankszámlaszámot adja vissza
            </p>
          </div>
        </FormField>
        <div className="modal-footer mt-lg-4 d-flex justify-content-around">
          <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">
            Mégse
          </button>
          <SubmitButton
            text="Változtatás"
            className={'btn btn-primary'}
            disabled={inProgress}
            inProgress={inProgress}
          />
        </div>
      </form>
    </div>
  );
};
